import { each, filter, map } from 'lodash-es';
import { makeAutoObservable } from 'mobx';
import { FileData, FileModel } from 'entities/file/model/fileModel';
import { FolderData, FolderModel } from 'entities/folder/model/folderModel';
import { SectionData, SectionModel } from 'entities/section/model/sectionModel';
import { TableData, TableModel } from 'entities/table/model/tableModel';

type SearchResultFolderData = FolderData & {
  files: FileData[];
  tables: TableData[];
};

export type SearchResultData = SectionData & {
  folders: SearchResultFolderData[];
};

export class SearchResultModel {
  public isPending = false;
  public isError = false;

  private _data: SearchResultData;

  private _sectionModel: SectionModel;
  private _folderModels: FolderModel[];

  public get section() {
    return this._sectionModel;
  }
  public get withFilesfolders() {
    return filter(this._folderModels, (folder) =>
      Boolean(folder.files?.length || folder.tables?.length)
    );
  }

  public get matchedFolders() {
    return filter(this._folderModels, (folder) =>
      Boolean(folder.data?.is_search_match)
    );
  }

  public get documentsCount() {
    let amount = 0;

    each(this.withFilesfolders, (fm) => {
      amount += fm.files?.length || 0;
      amount += fm.tables?.length || 0;
    });

    return amount;
  }

  constructor(data: SearchResultData) {
    this._data = data;
    this._sectionModel = new SectionModel(this._data);
    this._folderModels = map(this._data.folders, (folderData) => {
      const folderModel = new FolderModel(folderData);
      folderModel.setFiles(
        map(folderData.files, (data) => new FileModel(data))
      );
      folderModel.setTables(
        map(folderData.tables, (data) => new TableModel(data))
      );
      return folderModel;
    });

    makeAutoObservable(this);
  }
}
